"use client";

import type { AboutData } from "@/services/public.service";
import Image from "next/image";

function Icon({ name, className = "", fill = false }: { name: string; className?: string; fill?: boolean }) {
  return <span className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}>{name}</span>;
}

export default function AboutTeam({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  const team = about.team || [];
  if (team.length === 0) return null;

  return (
    <section className="container mx-auto px-6 py-16 md:py-20">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-ink-900 text-center mb-12">
        {t("فريقنا", "Our team")}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {team.map((m, i) => (
          <div key={i} className="text-center">
            <div className="relative w-28 h-28 mx-auto rounded-full overflow-hidden bg-clay-100 mb-4">
              {m.photo ? (
                <Image src={m.photo} alt={isAr ? m.name.ar : m.name.en} fill unoptimized className="object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-clay-600">
                  <Icon name="person" fill className="text-4xl" />
                </div>
              )}
            </div>
            <p className="font-bold text-ink-900">{isAr ? m.name.ar : m.name.en}</p>
            <p className="text-sm text-ink-500">{isAr ? m.role.ar : m.role.en}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
